import store from '../store'

export default async (to, from, next) => {
  // Se não está logado e não é página pública
  if (to.name !== 'login' && to.name !== 'confirmation' && to.name !== 'sso' && !store.getters['auth/hasToken']) {
    try {
      await store.dispatch('auth/ActionCheckToken')
      next({ path: to.path })
    } catch (err) {
      next({ name: 'login' })
    }
    return
  }

  // Se está na página de login mas já tem token
  if (to.name === 'login' && store.getters['auth/hasToken']) {
    next({ name: 'home' })
    return
  }

  // Carrega configurações RSVP se estiver autenticado
  if (store.getters['auth/hasToken'] && to.name !== 'login' && to.name !== 'confirmation') {
    const hasRsvpData = store.state.settingRSVP &&
                        store.state.settingRSVP.settingRSVP &&
                        Object.keys(store.state.settingRSVP.settingRSVP).length > 0

    if (!hasRsvpData) {
      try {
        await store.dispatch('settingRSVP/GetRSVP')
      } catch (err) {
        // Se falhar, apenas continua sem bloquear a navegação
        console.warn('Failed to load RSVP settings:', err)
      }
    }
  }

  // Módulo App: só acessível quando habilitado pelo Master Panel. Sem isto,
  // quem digita /app/... direto cai em telas que a API responde com 403.
  if (to.path === '/app' || to.path.startsWith('/app/')) {
    try {
      await store.dispatch('app/GetAppConfig')
    } catch (err) {
      console.warn('Failed to load App config:', err)
    }

    if (!store.getters['app/appEnabled']) {
      next({ name: 'home' })
      return
    }
  }

  // Verificação de roles (desabilitada temporariamente - usar sistema de permissões)
  // if (to.meta && to.meta.roles && to.meta.roles.length > 0 && !to.meta.roles.includes(store.getters['auth/userRole'])) {
  //   next({ name: 'unauthorized' })
  //   return
  // }

  next()
}
